import { render, staticRenderFns } from "./InfoGraphicsTreemap.vue?vue&type=template&id=6039bf06&scoped=true&"
import script from "./InfoGraphicsTreemap.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicsTreemap.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphicsTreemap.vue?vue&type=style&index=0&id=6039bf06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039bf06",
  null
  
)

export default component.exports